import CommunicationSettings from './CommunicationSettings.component';

export default CommunicationSettings;